import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";

import type { ISummaryCardButtonProps } from "@components/organisms/appointmentCard/components/appointmentCardButtons/types";
import classes from "@components/organisms/appointmentCard/components/appointmentCardButtons/styles.module.scss";
import { Button } from "@components/atoms/button";
import { path } from "@/routes/path";

export function SummaryCardButtons({
  canWriteAddendum = true,
  canWriteSummary = true,
  id,
  summaryNoteId,
}: ISummaryCardButtonProps) {
  const { t } = useTranslation("common");

  const navigate = useNavigate();

  return (
    <div className={clsx(classes.appointmentButtons)}>
      {/* Button to cancel the appointment */}

      <Button
        mode={"main"}
        label={t("write_visit_summary_note")}
        onClick={() => navigate(path.summaryNote.writeSummary.link(id))}
        disabled={!canWriteSummary}
      />
      {/* Button to join a video call */}
      <Button
        mode={"secondary"}
        label={t("write_addendum")}
        disabled={!canWriteAddendum}
        onClick={() =>
          navigate(path.summaryNote.writeAddendum.link(summaryNoteId))
        }
      />
    </div>
  );
}
